@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/destination-tab/clipping-studio-destination-tab.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.destination-tab {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.destination-tab__section-title {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.destination-tab__section-caption {
  font-size: 10px;
  font-weight: 400;
  text-transform: lowercase;
}
.destination-tab__destinations {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 6px;
  overflow: hidden;
}
.destination-tab__destination-card {
  transition: background 0.15s ease;
}
.destination-tab__destination-card:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.destination-tab__destination-card--selected {
  background: rgba(45, 187, 252, 0.04);
}
.destination-tab__destination-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
}
.destination-tab__destination-row:hover {
  background: rgba(0, 0, 0, 0.04);
}
.destination-tab__destination-check {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid rgb(194, 204, 219);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  transition: border-color 0.15s, background 0.15s;
}
.destination-tab__destination-row:hover .destination-tab__destination-check {
  border-color: rgb(123, 144, 164);
}
.destination-tab__destination-check--checked {
  background: rgb(45, 187, 252);
  border-color: rgb(45, 187, 252);
}
.destination-tab__destination-check--checked .destination-tab__check-icon {
  color: rgb(255, 255, 255);
  font-size: 12px;
  font-weight: 700;
}
.destination-tab__destination-body {
  flex: 1;
  min-width: 0;
}
.destination-tab__destination-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}
.destination-tab__destination-icon-wrap {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.destination-tab__destination-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.destination-tab__destination-icon ::ng-deep svg {
  width: 24px;
  height: 24px;
  display: block;
}
.destination-tab__destination-icon-wrap.platform--youtube {
  color: #FF0000;
}
.destination-tab__destination-icon-wrap.platform--facebook {
  color: #1877F2;
}
.destination-tab__destination-icon-wrap.platform--instagram {
  color: #E4405F;
}
.destination-tab__destination-icon-wrap.platform--twitch {
  color: #9146FF;
}
.destination-tab__destination-icon-wrap.platform--website {
  color: rgba(0, 0, 0, 0.54);
}
.destination-tab__destination-name {
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.destination-tab__destination-expand-btn {
  padding: 4px;
  border: none;
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
}
.destination-tab__destination-expand-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.destination-tab__chevron--open {
  display: inline-block;
  transform: rotate(180deg);
}
.destination-tab__destination-summary {
  font-size: 11px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}
.destination-tab__destination-expanded {
  padding: 0 12px 16px 12px;
}
.destination-tab__destination-expanded ::ng-deep icn-dropdown ul {
  max-height: 140px;
  overflow-y: auto;
}
.destination-tab__destination-expanded ::ng-deep .facebook-settings__dropdown--category ul {
  max-height: 126px;
}
.destination-tab__expanded-inner {
  background: rgb(235, 240, 244);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
}
.destination-tab__field-group {
  margin-top: 12px;
  margin-bottom: 1rem;
}
.destination-tab__field-group:last-child {
  margin-bottom: 0;
}
.destination-tab__field-group--border {
  padding-top: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.destination-tab__label {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  display: block;
  margin-bottom: 6px;
}
.destination-tab__label--primary {
  color: rgb(45, 187, 252);
}
.destination-tab__graphic-loading {
  padding: 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.destination-tab__graphic-error {
  padding: 12px;
  font-size: 12px;
  color: rgb(255, 76, 81);
  background: rgba(255, 76, 81, 0.08);
  border-radius: 8px;
}
.destination-tab__graphic-strip {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
}
.destination-tab__graphic-btn {
  position: relative;
  flex-shrink: 0;
  width: 96px;
  aspect-ratio: 4/3;
  border-radius: 8px;
  border: 2px solid rgb(255, 255, 255);
  background: rgb(255, 255, 255);
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.destination-tab__graphic-btn:hover {
  border-color: rgb(194, 204, 219);
}
.destination-tab__graphic-btn--active {
  border-color: rgb(45, 187, 252);
  box-shadow: 0 0 0 2px rgba(45, 187, 252, 0.2);
}
.destination-tab__graphic-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.destination-tab__graphic-placeholder {
  width: 100%;
  height: 100%;
  background: rgb(235, 240, 244);
  opacity: 0.5;
}
.destination-tab__graphic-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px;
  background:
    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8),
      transparent);
  font-size: 8px;
  font-weight: 800;
  color: rgb(255, 255, 255);
  text-transform: uppercase;
  text-align: center;
  line-height: 1.2;
}
.destination-tab__graphic-check {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(255, 255, 255);
}
.destination-tab__graphic-hint {
  margin-top: 8px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(45, 187, 252, 0.15);
  border-radius: 8px;
  font-size: 9px;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.3;
}
.destination-tab__graphic-hint .destination-tab__graphic-hint-label {
  font-weight: 700;
  color: rgb(45, 187, 252);
}
.destination-tab__grid {
  display: block;
}
.destination-tab__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.destination-tab__field--aspect-ratio {
  width: fit-content;
  margin: 0 auto;
  align-items: center;
}
.destination-tab__field--aspect-ratio .destination-tab__label {
  white-space: nowrap;
  text-align: center;
}
.destination-tab__dropdown {
  width: 100%;
}
.destination-tab__dropdown--aspect-ratio {
  width: 85% !important;
}
.destination-tab__dropdown--flex {
  flex: 1;
  min-width: 0;
}
.destination-tab__notice {
  margin: 12px 0;
  padding: 8px 10px;
  border: 1px solid rgba(45, 187, 252, 0.18);
  border-radius: 6px;
  background: rgba(45, 187, 252, 0.06);
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
  line-height: 1.4;
}
.destination-tab__readonly {
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  background: rgb(235, 240, 244);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
}
.destination-tab__lang-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.destination-tab__lang-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.destination-tab__lang-chip:hover {
  border-color: rgb(194, 204, 219);
}
.destination-tab__lang-chip--active {
  background: rgba(45, 187, 252, 0.1);
  border-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
}
.destination-tab__lang-check {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  border: 1px solid rgb(194, 204, 219);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  visibility: hidden;
}
.destination-tab__lang-check--on {
  visibility: visible;
  background: rgb(45, 187, 252);
  border-color: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.destination-tab__burnin-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.destination-tab__dual-btn {
  padding: 6px 8px;
  font-size: 9px;
  font-weight: 800;
  border-radius: 4px;
  border: 1px solid rgb(158, 77, 244);
  background: rgb(255, 255, 255);
  color: rgb(158, 77, 244);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}
.destination-tab__dual-btn:hover {
  background: rgba(158, 77, 244, 0.08);
}
.destination-tab__dual-btn--on {
  background: rgb(158, 77, 244);
  color: rgb(255, 255, 255);
  border-color: rgb(158, 77, 244);
}
.destination-tab__dual-plus {
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  flex-shrink: 0;
}
.destination-tab__checkbox-row {
  padding-top: 8px;
}
.destination-tab__checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.destination-tab__checkbox {
  width: 16px;
  height: 16px;
  accent-color: rgb(45, 187, 252);
  cursor: pointer;
}
.destination-tab__checkbox-text {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}
.destination-tab__spacer {
  height: 1rem;
}
/*# sourceMappingURL=clipping-studio-destination-tab.component.css.map */
